import { render, staticRenderFns } from "./editExpense.vue?vue&type=template&id=5fb0cc11&scoped=true&"
import script from "./editExpense.vue?vue&type=script&lang=js&"
export * from "./editExpense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb0cc11",
  null
  
)

export default component.exports